
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("9d6BC", function(module, exports) {
$parcel$export(module.exports, "default", () => $e187a8d32c4ec8a5$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $jpMnG = parcelRequire("jpMnG");


var $6mbqi = parcelRequire("6mbqi");


var $i4o81 = parcelRequire("i4o81");


var $grxv4 = parcelRequire("grxv4");

var $3rvSa = parcelRequire("3rvSa");


var $kZmsK = parcelRequire("kZmsK");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $5l1kQ = parcelRequire("5l1kQ");


var $inPa6 = parcelRequire("inPa6");


var $fZRom = parcelRequire("fZRom");


var $gi5bC = parcelRequire("gi5bC");


var $d925B = parcelRequire("d925B");

const $e187a8d32c4ec8a5$var$RenderMediaInline = ({ rendererAppearance: _rendererAppearance, clipboardAttrs: clipboardAttrs, collection: collectionName, eventHandlers: eventHandlers, identifier: identifier })=>{
    const [contextIdentifier, setContextIdentifier] = (0, $42omo.useState)();
    const [fileState, setFileState] = (0, $42omo.useState)();
    const mediaClient = (0, $42omo.useContext)((0, $3rvSa.MediaClientContext));
    const contextIdentifierProvider = (0, $6mbqi.useProvider)('contextIdentifierProvider');
    (0, $42omo.useEffect)(()=>{
        if (contextIdentifierProvider) contextIdentifierProvider.then((resolvedContextID)=>{
            if (contextIdentifier !== resolvedContextID) setContextIdentifier(resolvedContextID);
        });
    }, [
        contextIdentifier,
        contextIdentifierProvider
    ]);
    const updateFileState = (0, $42omo.useCallback)(async (id)=>{
        const options = {
            collectionName: collectionName
        };
        try {
            if (mediaClient) {
                const fileState = await mediaClient.file.getCurrentState(id, options);
                setFileState(fileState);
            }
        } catch (error) {
        // eslint-disable-line no-unused-vars
        // do not set state on error
        }
    }, [
        collectionName,
        mediaClient
    ]);
    (0, $42omo.useEffect)(()=>{
        const { id: id } = identifier;
        const nodeIsInCache = id && (0, $5l1kQ.mediaIdentifierMap).has(id);
        if (!nodeIsInCache) (0, $5l1kQ.mediaIdentifierMap).set(identifier.id, {
            ...identifier,
            collectionName: collectionName
        });
        return ()=>{
            (0, $5l1kQ.mediaIdentifierMap).delete(id);
        };
    }, [
        identifier,
        collectionName
    ]);
    (0, $42omo.useEffect)(()=>{
        const { id: id } = clipboardAttrs;
        // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- Ignored via go/ees017 (to be fixed)
        id && updateFileState(id);
    }, [
        contextIdentifier,
        clipboardAttrs,
        updateFileState
    ]);
    /*
   * Only show the loading view if the media client is not ready
   * prevents calling the media API before the provider is ready
   */ if (!mediaClient) return /*#__PURE__*/ (0, $l998X.jsx)((0, $kZmsK.MediaInlineCardLoadingView), {
        message: "",
        isSelected: false
    });
    const handleMediaInlineClick = (result)=>{
        if (eventHandlers?.media?.onClick) eventHandlers?.media?.onClick(result);
    };
    const shouldOpenMediaViewer = true;
    const shouldDisplayToolTip = true;
    const { id: id, collection: collection } = clipboardAttrs;
    return(// eslint-disable-next-line @atlaskit/design-system/prefer-primitives
    /*#__PURE__*/ (0, $l998X.jsx)("span", {
        ...(0, $5l1kQ.getClipboardAttrs)({
            id: id,
            collection: collection,
            contextIdentifierProvider: contextIdentifier,
            fileState: fileState
        }),
        "data-node-type": "mediaInline",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $i4o81.default), {
            identifier: identifier,
            onClick: handleMediaInlineClick,
            shouldOpenMediaViewer: shouldOpenMediaViewer,
            shouldDisplayToolTip: shouldDisplayToolTip,
            mediaClientConfig: mediaClient.mediaClientConfig,
            mediaViewerItems: Array.from((0, $5l1kQ.mediaIdentifierMap).values())
        })
    }));
};
const $e187a8d32c4ec8a5$var$MediaInline = (props)=>{
    const { collection: collection, id: id, intl: intl, rendererAppearance: rendererAppearance, featureFlags: featureFlags, type: fileType, alt: alt, width: width, height: height, marks: marks, ssr: ssr } = props;
    const clipboardAttrs = {
        id: id,
        collection: collection
    };
    const identifier = {
        id: id,
        mediaItemType: 'file',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        collectionName: collection
    };
    const mediaClient = (0, $42omo.useContext)((0, $3rvSa.MediaClientContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    if (fileType === 'image') {
        const hasLinkMark = marks?.find((mark)=>mark.type.name === 'link');
        const borderMark = marks?.find((mark)=>mark?.type.name === 'border');
        const borderColor = borderMark?.attrs.color ?? '';
        const borderSize = borderMark?.attrs.size ?? 0;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $fZRom.ErrorBoundary), {
            component: (0, $gi5bC.ACTION_SUBJECT).RENDERER,
            componentId: (0, $d925B.ACTION_SUBJECT_ID).MEDIA_INLINE_IMAGE,
            createAnalyticsEvent: createAnalyticsEvent,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $jpMnG.MediaInlineImageCard), {
                mediaClient: ssr?.config ? (0, $grxv4.getMediaClient)(ssr.config) : mediaClient,
                identifier: identifier,
                alt: alt,
                width: width,
                height: height,
                ssr: ssr,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                border: {
                    borderSize: borderSize,
                    borderColor: borderColor
                },
                serializeDataAttrs: true,
                shouldOpenMediaViewer: !hasLinkMark
            })
        });
    }
    return /*#__PURE__*/ (0, $l998X.jsx)($e187a8d32c4ec8a5$var$RenderMediaInline, {
        identifier: identifier,
        clipboardAttrs: clipboardAttrs,
        eventHandlers: props.eventHandlers,
        rendererAppearance: rendererAppearance,
        intl: intl,
        collection: collection,
        featureFlags: featureFlags
    });
};
var $e187a8d32c4ec8a5$export$2e2bcd8739ae039 = (0, $aXWIB.injectIntl)($e187a8d32c4ec8a5$var$MediaInline);

});

parcelRegister("5l1kQ", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $lcuos = parcelRequire("lcuos");


var $1BiXn = parcelRequire("1BiXn");

var $lasm3 = parcelRequire("lasm3");

var $9s7Po = parcelRequire("9s7Po");

var $8yFQr = parcelRequire("8yFQr");


var $3rvSa = parcelRequire("3rvSa");


var $8Doca = parcelRequire("8Doca");


var $1oCLl = parcelRequire("1oCLl");


var $iu6m9 = parcelRequire("iu6m9");


var $6uN0A = parcelRequire("6uN0A");


var $d925B = parcelRequire("d925B");

const $c97c7f2b7cd82c79$export$7da2d00ddd5627a6 = new Map();
const $c97c7f2b7cd82c79$export$e689a46890560dbd = (doc)=>{
    if (!doc) return [];
    return (0, $lcuos.filter)(doc, (node)=>node.type === 'media').reduce((identifierList, mediaNode)=>{
        if (mediaNode.attrs) {
            const { type: type, url: dataURI, id: id } = mediaNode.attrs;
            if (type === 'file' && id) identifierList.push({
                mediaItemType: 'file',
                id: id
            });
            else if (type === 'external' && dataURI) identifierList.push({
                mediaItemType: 'external-image',
                dataURI: dataURI,
                name: dataURI
            });
        }
        return identifierList;
    }, []);
};
class $c97c7f2b7cd82c79$export$cfff5eb155a82d30 extends (0, $42omo.Component) {
    async componentDidMount() {
        const { rendererContext: rendererContext, contextIdentifierProvider: contextIdentifierProvider, id: id, url: url, collection: collectionName } = this.props;
        if (contextIdentifierProvider) this.setState({
            contextIdentifierProvider: await contextIdentifierProvider
        });
        const nodeIsInCache = id && $c97c7f2b7cd82c79$export$7da2d00ddd5627a6.has(id) || url && $c97c7f2b7cd82c79$export$7da2d00ddd5627a6.has(url);
        if (rendererContext && rendererContext.adDoc && !nodeIsInCache) $c97c7f2b7cd82c79$export$e689a46890560dbd(rendererContext.adDoc).forEach((identifier)=>{
            if (identifier.mediaItemType === 'file' && identifier.id === id) $c97c7f2b7cd82c79$export$7da2d00ddd5627a6.set(identifier.id, {
                ...identifier,
                collectionName: collectionName
            });
            else if (identifier.mediaItemType === 'external-image') $c97c7f2b7cd82c79$export$7da2d00ddd5627a6.set(identifier.dataURI, identifier);
        });
        if (id) this.saveFileState(id);
    }
    componentDidUpdate(prevProps) {
        const { id: oldId } = prevProps;
        if (this.props.id && oldId !== this.props.id) this.saveFileState(this.props.id);
    }
    componentWillUnmount() {
        const { id: id, url: dataURI } = this.props;
        if (id) $c97c7f2b7cd82c79$export$7da2d00ddd5627a6.delete(id);
        else if (dataURI) $c97c7f2b7cd82c79$export$7da2d00ddd5627a6.delete(dataURI);
    }
    renderExternal(shouldOpenMediaViewer) {
        const { cardDimensions: cardDimensions, resizeMode: resizeMode, appearance: appearance, url: url, imageStatus: imageStatus, disableOverlay: disableOverlay, alt: alt, featureFlags: featureFlags, ssr: ssr, mediaClient: mediaClient, dataAttributes: dataAttributes, enableSyncMediaCard: enableSyncMediaCard, localId: localId } = this.props;
        if (imageStatus === 'loading' || !url) return this.renderLoadingCard();
        const identifier = {
            dataURI: url,
            name: url,
            mediaItemType: 'external-image'
        };
        // we need this statement for the mandatory mediaClientConfig below
        const mediaClientConfig = mediaClient?.mediaClientConfig;
        const Card = enableSyncMediaCard ? (0, $8yFQr.default) : (0, $1BiXn.default);
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        /*#__PURE__*/ (0, $l998X.jsx)("div", {
            ...dataAttributes,
            "data-node-type": "media",
            "data-local-id": localId,
            children: /*#__PURE__*/ (0, $l998X.jsx)(Card, {
                // TODO: MPT-315 - clean up after we move mediaClientConfig into FileIdentifier
                // context is not really used when the type is external and we want to render the component asap
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                mediaClientConfig: mediaClientConfig,
                alt: alt,
                identifier: identifier,
                dimensions: cardDimensions,
                appearance: appearance,
                resizeMode: resizeMode,
                disableOverlay: disableOverlay,
                shouldOpenMediaViewer: shouldOpenMediaViewer,
                mediaViewerItems: Array.from($c97c7f2b7cd82c79$export$7da2d00ddd5627a6.values()),
                featureFlags: featureFlags,
                ssr: ssr?.mode,
                shouldHideTooltip: false,
                onError: (0, $1oCLl.expValEquals)('platform_editor_media_error_analytics', 'isEnabled', true) ? this.onError : undefined
            })
        }));
    }
    render() {
        const { contextIdentifierProvider: contextIdentifierProvider, fileState: fileState } = this.state;
        const { id: id, alt: alt, type: type, collection: collection, occurrenceKey: occurrenceKey, cardDimensions: cardDimensions, resizeMode: resizeMode, disableOverlay: disableOverlay, useInlinePlayer: useInlinePlayer, originalDimensions: originalDimensions, shouldOpenMediaViewer: forceOpenMediaViewer, featureFlags: featureFlags, shouldEnableDownloadButton: shouldEnableDownloadButton, ssr: ssr, mediaClient: mediaClient, dataAttributes: dataAttributes, enableSyncMediaCard: enableSyncMediaCard, localId: localId, mediaViewerExtensions: mediaViewerExtensions } = this.props;
        const isMobile = false;
        const shouldPlayInline = useInlinePlayer !== undefined ? useInlinePlayer : true;
        const isInlinePlayer = isMobile ? false : shouldPlayInline;
        const onCardClick = this.getOnCardClickCallback(isInlinePlayer);
        const shouldOpenMediaViewer = typeof forceOpenMediaViewer === 'boolean' ? forceOpenMediaViewer : !isMobile && !onCardClick;
        if (type === 'external') return this.renderExternal(shouldOpenMediaViewer);
        if (type === 'link') return null;
        const mediaClientConfig = !!ssr ? ssr.config : mediaClient?.mediaClientConfig;
        if (!mediaClientConfig || !id) return this.renderLoadingCard();
        if (!id || type !== 'file') return /*#__PURE__*/ (0, $l998X.jsx)((0, $lasm3.CardError), {
            dimensions: cardDimensions
        });
        const contextId = contextIdentifierProvider && contextIdentifierProvider.objectId;
        const identifier = {
            id: id,
            mediaItemType: 'file',
            collectionName: collection,
            occurrenceKey: occurrenceKey
        };
        const Card = enableSyncMediaCard ? (0, $8yFQr.default) : (0, $1BiXn.default);
        // Quick solution to disable lazy loading of images on PDF export pages in Confluence to remedy an issue with images never loading
        // More robust solution will be implemented as part of CCPDF-233 - Link: https://hello.jira.atlassian.cloud/browse/CCPDF-233
        const currentUrl = window.location.href;
        const shouldDisableLazyLoading = (0, $1oCLl.expValEquals)('platform_editor_disable_lazy_load_media', 'isEnabled', true) && currentUrl.includes('/wiki/pdf/spaces/');
        return /*#__PURE__*/ (0, $l998X.jsx)("div", {
            ...$c97c7f2b7cd82c79$export$92bef806f5be5d7c({
                id: id,
                alt: alt,
                collection: collection,
                contextIdentifierProvider: contextIdentifierProvider,
                originalDimensions: originalDimensions,
                fileState: fileState
            }),
            ...dataAttributes,
            "data-local-id": localId,
            children: /*#__PURE__*/ (0, $l998X.jsx)(Card, {
                identifier: identifier,
                alt: alt,
                contextId: contextId,
                mediaClientConfig: mediaClientConfig,
                dimensions: cardDimensions,
                originalDimensions: originalDimensions,
                onClick: onCardClick,
                resizeMode: resizeMode,
                isLazy: !isMobile && !shouldDisableLazyLoading,
                disableOverlay: disableOverlay,
                useInlinePlayer: isInlinePlayer,
                shouldOpenMediaViewer: shouldOpenMediaViewer,
                mediaViewerItems: Array.from($c97c7f2b7cd82c79$export$7da2d00ddd5627a6.values()),
                featureFlags: featureFlags,
                shouldEnableDownloadButton: shouldEnableDownloadButton,
                ssr: ssr?.mode,
                shouldHideTooltip: isMobile,
                mediaViewerExtensions: mediaViewerExtensions,
                onError: (0, $1oCLl.expValEquals)('platform_editor_media_error_analytics', 'isEnabled', true) ? this.onError : undefined
            })
        });
    }
    constructor(...args){
        super(...args);
        this.state = {};
        this.saveFileState = async (id)=>{
            const { collection: collectionName, mediaClient: mediaClient } = this.props;
            const options = {
                collectionName: collectionName
            };
            try {
                if (mediaClient) {
                    const fileState = await mediaClient.file.getCurrentState(id, options);
                    this.setState({
                        fileState: fileState
                    });
                }
            } catch  {
            // do not set state on error
            }
        };
        this.onError = (reason)=>{
            const { nestedUnder: nestedUnder, rendererContext: rendererContext } = this.props;
            this.props.fireAnalyticsEvent?.({
                action: (0, $d925B.ACTION).ERRORED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).RENDERER,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).MEDIA,
                eventType: (0, $d925B.EVENT_TYPE).UI,
                attributes: {
                    reason: reason,
                    external: false,
                    ...nestedUnder && (0, $iu6m9.editorExperiment)('platform_synced_block', true) ? {
                        nestedUnder: nestedUnder
                    } : {},
                    ...rendererContext?.nestedRendererType && (0, $iu6m9.editorExperiment)('platform_synced_block', true) ? {
                        nestedRendererType: rendererContext.nestedRendererType
                    } : {}
                }
            });
        };
        this.renderLoadingCard = ()=>{
            const { cardDimensions: cardDimensions } = this.props;
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $9s7Po.CardLoading), {
                dimensions: cardDimensions,
                interactionName: "renderer-media-card-loading"
            });
        };
        /**
     * We want to call provided `eventHandlers.media.onClick` when it's provided,
     * but we also don't want to call it when it's a video and inline video player is enabled.
     * This is due to consumers normally process this onClick call by opening media viewer and
     * we don't want that to happened described above text.
     */ this.getOnCardClickCallback = (isInlinePlayer)=>{
            const { eventHandlers: eventHandlers } = this.props;
            if (eventHandlers && eventHandlers.media && eventHandlers.media.onClick) return (result, analyticsEvent)=>{
                const isVideo = result.mediaItemDetails && result.mediaItemDetails.mediaType === 'video';
                const isVideoWithInlinePlayer = isInlinePlayer && isVideo;
                if (!isVideoWithInlinePlayer && eventHandlers && eventHandlers.media && eventHandlers.media.onClick) eventHandlers.media.onClick(result, analyticsEvent);
            };
            return undefined;
        };
    }
}
const $c97c7f2b7cd82c79$export$92bef806f5be5d7c = ({ id: id, alt: alt, collection: collection, contextIdentifierProvider: contextIdentifierProvider, originalDimensions: originalDimensions, fileState: fileState })=>{
    const contextId = contextIdentifierProvider && contextIdentifierProvider.objectId;
    const width = originalDimensions && originalDimensions.width;
    const height = originalDimensions && originalDimensions.height;
    let fileName = 'file'; // default name is needed for Confluence
    let fileSize = 1;
    let fileMimeType = '';
    if (fileState && fileState.status !== 'error') {
        fileSize = fileState.size;
        fileName = fileState.name;
        fileMimeType = fileState.mimeType;
    }
    return {
        'data-context-id': contextId,
        'data-type': 'file',
        'data-node-type': 'media',
        'data-width': width,
        'data-height': height,
        'data-id': id,
        'data-collection': collection,
        'data-file-name': fileName,
        'data-file-size': fileSize,
        'data-file-mime-type': fileMimeType,
        'data-alt': alt
    };
};
const $c97c7f2b7cd82c79$export$fae4803d1ca121c8 = (props)=>{
    const mediaClient = (0, $42omo.useContext)((0, $3rvSa.MediaClientContext));
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6uN0A.default).Consumer, {
        children: ({ fireAnalyticsEvent: fireAnalyticsEvent })=>{
            return /*#__PURE__*/ (0, $l998X.jsx)($c97c7f2b7cd82c79$export$cfff5eb155a82d30, {
                ...props,
                mediaClient: mediaClient,
                fireAnalyticsEvent: fireAnalyticsEvent
            });
        }
    });
};
const $c97c7f2b7cd82c79$export$a6543a2e3828db2c = (0, $8Doca.withImageLoader)($c97c7f2b7cd82c79$export$fae4803d1ca121c8);
module.exports["mediaIdentifierMap"] = $c97c7f2b7cd82c79$export$7da2d00ddd5627a6;
module.exports["getClipboardAttrs"] = $c97c7f2b7cd82c79$export$92bef806f5be5d7c;
module.exports["MediaCard"] = $c97c7f2b7cd82c79$export$a6543a2e3828db2c;

});

parcelRegister("lcuos", function(module, exports) {

var $6jPem = parcelRequire("6jPem");

function $da92954c57c92ae9$export$3dea766d36a8935f(adf, callback) {
    const result = [];
    (0, $6jPem.traverse)(adf, {
        any: (node)=>{
            if (callback(node)) result.push(node);
        }
    });
    return result;
}
module.exports["filter"] = $da92954c57c92ae9$export$3dea766d36a8935f;

});

parcelRegister("1BiXn", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4wH3g = parcelRequire("4wH3g");


var $dh538 = parcelRequire("dh538");


var $9s7Po = parcelRequire("9s7Po");


var $hnvzE = parcelRequire("hnvzE");

const $2f66d7816a46cebf$var$MediaCardContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({});
const $2f66d7816a46cebf$var$CardLoadingWithContext = ()=>{
    const props = (0, $42omo.useContext)($2f66d7816a46cebf$var$MediaCardContext);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9s7Po.CardLoading), {
        ...props,
        interactionName: "media-card-async-loading"
    });
};

function $2f66d7816a46cebf$var$loadCardWithMediaClient() {
    return Promise.resolve((parcelRequire("r0CCR")));
}
const $2f66d7816a46cebf$var$MediaCardWithMediaClientLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "a0IPb",
    name: "MediaCardWithMediaClientLoadable",
    loader: ()=>$2f66d7816a46cebf$var$loadCardWithMediaClient().then((mod)=>mod.CardWithMediaClient),
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2f66d7816a46cebf$var$CardLoadingWithContext, null)
});
const $2f66d7816a46cebf$var$MediaCardWithMediaClientLazy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>$2f66d7816a46cebf$var$loadCardWithMediaClient().then((mod)=>({
            default: mod.CardWithMediaClient
        })));
const $2f66d7816a46cebf$var$CardLoader = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnvzE.default), {
        name: "media-card",
        mode: "list"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2f66d7816a46cebf$var$MediaCardContext.Provider, {
        value: props
    }, (0, $dh538.fg)('platform_media_react19_support') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2f66d7816a46cebf$var$CardLoadingWithContext, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2f66d7816a46cebf$var$MediaCardWithMediaClientLazy, props)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2f66d7816a46cebf$var$MediaCardWithMediaClientLoadable, props)));
};
$2f66d7816a46cebf$var$CardLoader.preload = ()=>{
    if ((0, $dh538.fg)('platform_media_react19_support')) $2f66d7816a46cebf$var$loadCardWithMediaClient().then(()=>{});
    else $2f66d7816a46cebf$var$MediaCardWithMediaClientLoadable.preload?.();
};
var $2f66d7816a46cebf$export$2e2bcd8739ae039 = $2f66d7816a46cebf$var$CardLoader;
module.exports["default"] = $2f66d7816a46cebf$export$2e2bcd8739ae039;

});

parcelRegister("9s7Po", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fDGbV = parcelRequire("fDGbV");


var $64ehG = parcelRequire("64ehG");


var $9hlns = parcelRequire("9hlns");

class $bf3fa0f5391f39b8$export$5d25853fd6bdf402 extends (0, $42omo.Component) {
    render() {
        const { dimensions: dimensionsProp, testId: testId, interactionName: interactionName } = this.props;
        const dimensions = (0, $fDGbV.getDimensionsWithDefault)(dimensionsProp);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $64ehG.Wrapper), {
            "data-testid": testId || 'media-card-loading',
            "data-test-loading": true,
            dimensions: dimensions,
            "data-vc": "media-card-loading"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            interactionName: interactionName || 'media-card-loading'
        }));
    }
}
module.exports["CardLoading"] = $bf3fa0f5391f39b8$export$5d25853fd6bdf402;

});

parcelRegister("64ehG", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $1CyYH = parcelRequire("1CyYH");

const $fd9c20c94dd40490$export$e6dfd72ab29f8598 = (props)=>{
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: (0, $1CyYH.wrapperStyles)({
            dimensions: props.dimensions
        }),
        ...props
    }, props.children));
};
module.exports["Wrapper"] = $fd9c20c94dd40490$export$e6dfd72ab29f8598;

});

parcelRegister("1CyYH", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $fN2NR = parcelRequire("fN2NR");

const $aedc46c8c12477c6$export$491e6397d7c1480b = ({ dimensions: dimensions })=>/*#__PURE__*/ (0, $9K4OG.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $fN2NR.center), "background:var(--ds-background-neutral, #0515240F);color:var(--ds-icon, #292A2E);", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $fN2NR.borderRadius), {
        maxHeight: '100%',
        maxWidth: '100%',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: dimensions.width,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: dimensions.height
    });
module.exports["wrapperStyles"] = $aedc46c8c12477c6$export$491e6397d7c1480b;

});

parcelRegister("fN2NR", function(module, exports) {
const $adbace133e9e6202$export$a5b94313d6908893 = (maxWidth = '100%')=>{
    const unit = typeof maxWidth === 'number' ? 'px' : '';
    return `
    max-width: ${maxWidth}${unit};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `;
};
const $adbace133e9e6202$export$346677f925de839c = (value = '100%')=>{
    const unit = typeof value === 'number' ? 'px' : '';
    return `
    width: ${value}${unit};
    height: ${value}${unit};
  `;
};
const $adbace133e9e6202$export$3481c78889e8fbe8 = `
  display: flex;
  align-items: center;
  justify-content: center;
`;
const $adbace133e9e6202$export$d31af2dc8039efd3 = (top = 0, left = 0)=>`
  position: absolute;
  top: ${top}px;
  left: ${left}px;
`;
const $adbace133e9e6202$export$7a57f79000377ca2 = `
  border-radius: ${"var(--ds-radius-small, 3px)"};
`;
const $adbace133e9e6202$export$a98155aef1bfd63 = `
  border-bottom-left-radius: ${"var(--ds-radius-small, 3px)"};
  border-bottom-right-radius: ${"var(--ds-radius-small, 3px)"};
`;
const $adbace133e9e6202$export$24656b269d8df7d6 = 'cubic-bezier(0.645, 0.045, 0.355, 1)';
module.exports["size"] = $adbace133e9e6202$export$346677f925de839c;
module.exports["center"] = $adbace133e9e6202$export$3481c78889e8fbe8;
module.exports["borderRadius"] = $adbace133e9e6202$export$7a57f79000377ca2;

});

parcelRegister("lasm3", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gUYJl = parcelRequire("gUYJl");


var $64ehG = parcelRequire("64ehG");


var $fDGbV = parcelRequire("fDGbV");

class $4d827ca5540b7b64$export$f7f7efdefcc02999 extends (0, $42omo.Component) {
    render() {
        const dimensions = (0, $fDGbV.getDimensionsWithDefault)(this.props.dimensions);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $64ehG.Wrapper), {
            dimensions: dimensions
        }, this.icon);
    }
    get icon() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gUYJl.ErrorIcon), null);
    }
}
module.exports["CardError"] = $4d827ca5540b7b64$export$f7f7efdefcc02999;

});

parcelRegister("gUYJl", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $ebrpi = parcelRequire("ebrpi");


var $deU3H = parcelRequire("deU3H");

class $cc3567b97db2e0fc$export$19bc16ee58e19b3d extends (0, $42omo.Component) {
    render() {
        return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: (0, $deU3H.errorIconWrapperStyles)
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ebrpi))), {
            color: "currentColor",
            label: "Error"
        })));
    }
}
module.exports["ErrorIcon"] = $cc3567b97db2e0fc$export$19bc16ee58e19b3d;

});

parcelRegister("deU3H", function(module, exports) {
function $1a717317aba342a5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1a717317aba342a5$export$8dcf6b831a37de79 = {
    name: "5taie3",
    styles: "display:flex;color:var(--ds-icon-warning, #E06C00)"
};
module.exports["errorIconWrapperStyles"] = $1a717317aba342a5$export$8dcf6b831a37de79;

});

parcelRegister("8yFQr", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hnvzE = parcelRequire("hnvzE");


var $r0CCR = parcelRequire("r0CCR");

const $fae0b8a709d3e7ba$var$CardSync = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnvzE.default), {
        name: "media-card-sync",
        mode: "list"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $r0CCR.CardWithMediaClient), props));
};
var $fae0b8a709d3e7ba$export$2e2bcd8739ae039 = $fae0b8a709d3e7ba$var$CardSync;
module.exports["default"] = $fae0b8a709d3e7ba$export$2e2bcd8739ae039;

});

parcelRegister("eWRwJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca4f3d8c1426d3d8$export$2e2bcd8739ae039);
var $ca4f3d8c1426d3d8$export$2e2bcd8739ae039 = (channel)=>(payload)=>(createAnalyticsEvent)=>{
            const consumerEvent = createAnalyticsEvent(payload);
            const clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };

});

parcelRegister("9JpPs", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

function $c712b10e1cbb5738$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>condition() ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, $l998X.jsx)(ComponentTrue, {
            ...props,
            ref: ref
        }) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, $l998X.jsx)(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ComponentWithCondition;
}
module.exports["componentWithCondition"] = $c712b10e1cbb5738$export$6e8ea24b15199873;

});

parcelRegister("5TGLQ", function(module, exports) {

var $gL6du = parcelRequire("gL6du");


var $aw01o = parcelRequire("aw01o");


var $a6FC8 = parcelRequire("a6FC8");

const $0aa0cd7558ee373c$export$ea56ca58f08ffa52 = (locale, formatterOptions)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $gL6du.normalizeLocale)(locale);
    const formatDate = (date)=>Intl.DateTimeFormat(normalizedLocale).format(date);
    const formatTime = (date)=>Intl.DateTimeFormat(normalizedLocale, {
            hour: 'numeric',
            minute: 'numeric'
        }).format(date);
    const getDays = (weekStartDay = 0, length)=>{
        const dayFormatter = Intl.DateTimeFormat(normalizedLocale, {
            weekday: length
        });
        // Right now there is no way to find out first day of the week based on Intl (locale)
        // api. Check issue here: https://github.com/tc39/ecma402/issues/6
        // So we rotate the weekdays based on #weekStartDay parameter.
        const weekdays = [
            0,
            1,
            2,
            3,
            4,
            5,
            6
        ];
        const rotatedWeekdays = weekStartDay > 0 ? [
            ...weekdays.slice(weekStartDay),
            ...weekdays.slice(0, weekStartDay)
        ] : weekdays;
        return rotatedWeekdays.map((day)=>{
            // Some short days are longer than 3 characters but are unique if the first
            // three non-white characters are used.
            const result = dayFormatter// Date range chosen which has a Sun-Sat range so we can extract the names
            .format(new Date(2000, 9, day + 1, 12))// \u200E matches on the Left-to-Right Mark character in IE/Edge
            .replace(/[\s\u200E]/g, '');
            // If short days, only return first three characters. Else return whole thing
            if (length === 'short') return result.substring(0, 3);
            else return result;
        });
    };
    const getDaysShort = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'short');
    };
    const getDaysLong = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'long');
    };
    const getMonthsLong = ()=>{
        const monthFormatter = Intl.DateTimeFormat(normalizedLocale, {
            month: 'long'
        });
        return [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ].map((month)=>// Date chosen for no real reason, the only important part is the month
            // Using 2020 'cos Safari has a faulty implementation when we use the year 2000
            // Intl.DateTimeFormat("en-US", { month: 'long'}).format(new Date(2000, 3, 1))
            // should give "April" but gives "March" in Safari
            monthFormatter.format(new Date(2020, month, 1)));
    };
    const parseDate = (date, options = {})=>(0, $aw01o.createDateParser)(normalizedLocale)(date, options);
    const formatToParts = (date = new Date())=>{
        const formatter = new Intl.DateTimeFormat(normalizedLocale, formatterOptions);
        /**
		 * Safari has a bug that returns the wrong month for years 2005 and before.
		 * The error occurs when the passed date has been created with numbers, like new Date(2000, 3, 1)
		 * Not all the months fail in each year. To ensure the correct output,
		 * we select 2020 as the base year for the whole date,
		 * then we replace in the result the original input year
		 */ const fixedDate = new Date(date);
        fixedDate.setFullYear(2020);
        const fixedParts = (0, $a6FC8.toFormattedParts)(formatter.formatToParts(fixedDate));
        const originalParts = (0, $a6FC8.toFormattedParts)(formatter.formatToParts(date));
        if (fixedParts.year) fixedParts.year = originalParts.year;
        /**
		 * Chrome has a bug that returns hour="00" when it's 12:00pm in certain languages
		 * We fix it by detecting the real time with getHours method
		 */ if (fixedParts.hour === '00' && fixedDate.getHours() === 12) fixedParts.hour = '12';
        return fixedParts;
    };
    return {
        getDaysShort: getDaysShort,
        getDaysLong: getDaysLong,
        getMonthsLong: getMonthsLong,
        formatDate: formatDate,
        formatTime: formatTime,
        parseDate: parseDate,
        formatToParts: formatToParts
    };
};
module.exports["createLocalizationProvider"] = $0aa0cd7558ee373c$export$ea56ca58f08ffa52;

});

parcelRegister("gL6du", function(module, exports) {
const $21e9301be8cff986$export$dca0327c9b9c6498 = (locale)=>locale.replace(/_/g, '-');
module.exports["normalizeLocale"] = $21e9301be8cff986$export$dca0327c9b9c6498;

});

parcelRegister("aw01o", function(module, exports) {

var $gL6du = parcelRequire("gL6du");


var $3nGJd = parcelRequire("3nGJd");


var $4eigd = parcelRequire("4eigd");


var $2iEso = parcelRequire("2iEso");

const $734802129a3b7f4d$var$INVALID_DATE = new Date(NaN);
const $734802129a3b7f4d$var$INVARIANT = {
    year: 1993,
    month: 2,
    day: 18
};
const $734802129a3b7f4d$var$INVARIANT_DATE = (0, $2iEso.toDate)($734802129a3b7f4d$var$INVARIANT);
const $734802129a3b7f4d$var$FORMAT_EXTRACTOR_REGEX = /(\d+)[^\d]+(\d+)[^\d]+(\d+)\.?/;
const $734802129a3b7f4d$var$DATE_PARSER_REGEX = /(\d+)[^\d]*(\d+)?[^\d]*(\d+)?\.?/;
// Internet Explorer returns non-printing characters when formatting a date
const $734802129a3b7f4d$var$stripExtras = (str)=>str.replace(/\u200E/g, '');
const $734802129a3b7f4d$var$extractDateParts = (matchResult)=>{
    return matchResult// Get the 3 capture groups
    .splice(1, 4)// Convert them to numbers
    .map((datePart)=>parseInt(datePart, 10));
};
const $734802129a3b7f4d$export$cfa2ef2687faeda2 = (locale)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $gL6du.normalizeLocale)(locale);
    const dateFormatter = Intl.DateTimeFormat(normalizedLocale);
    // Generate a date string from a hard coded date, this allows us to determine
    // the year/month/day position for the provided locale.
    const rawDateString = dateFormatter.format($734802129a3b7f4d$var$INVARIANT_DATE);
    const shortDate = $734802129a3b7f4d$var$stripExtras(rawDateString);
    // Extract the date pieces from the locale formatted date string
    const formatMatch = shortDate.match($734802129a3b7f4d$var$FORMAT_EXTRACTOR_REGEX);
    if (!formatMatch) throw new Error('Unable to create DateParser');
    const formatParts = $734802129a3b7f4d$var$extractDateParts(formatMatch);
    // Find the year/month/day positions of the locale formatted invariant date
    const yearPosition = formatParts.indexOf($734802129a3b7f4d$var$INVARIANT.year);
    const monthPosition = formatParts.indexOf($734802129a3b7f4d$var$INVARIANT.month);
    const dayPosition = formatParts.indexOf($734802129a3b7f4d$var$INVARIANT.day);
    return (date, options = {})=>{
        const dateMatch = $734802129a3b7f4d$var$stripExtras(date).match($734802129a3b7f4d$var$DATE_PARSER_REGEX);
        if (!dateMatch) return $734802129a3b7f4d$var$INVALID_DATE;
        const dateParts = $734802129a3b7f4d$var$extractDateParts(dateMatch);
        // Use the previously extracted year/month/day positions to extract each
        // date piece.
        const extractedDate = {
            year: dateParts[yearPosition],
            month: dateParts[monthPosition],
            day: dateParts[dayPosition]
        };
        const normalizedDate = (0, $4eigd.normalizeDate)(extractedDate, options?.defaultFirstDay);
        if (!(0, $3nGJd.isValid)(normalizedDate)) return $734802129a3b7f4d$var$INVALID_DATE;
        return (0, $2iEso.toDate)(normalizedDate);
    };
};
module.exports["createDateParser"] = $734802129a3b7f4d$export$cfa2ef2687faeda2;

});

parcelRegister("3nGJd", function(module, exports) {

var $7sNuF = parcelRequire("7sNuF");

const $7f0fa5875d6e9a42$export$1ea939691cdc45b8 = (date)=>{
    const { year: year, month: month, day: day } = date;
    const daysInMonth = (0, $7sNuF.getDaysInMonth)(year, month);
    return 1 <= month && month <= 12 && 1 <= day && day <= daysInMonth;
};
module.exports["isValid"] = $7f0fa5875d6e9a42$export$1ea939691cdc45b8;

});

parcelRegister("7sNuF", function(module, exports) {

var $1RvqY = parcelRequire("1RvqY");

const $320ec45740b0ee24$export$f645ddd439eb259d = (year, month)=>{
    // February depends on leap year
    if (month === 2 && (0, $1RvqY.isLeapYear)(year)) return 29;
    return [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][month - 1];
};
module.exports["getDaysInMonth"] = $320ec45740b0ee24$export$f645ddd439eb259d;

});

parcelRegister("1RvqY", function(module, exports) {
const $323f2e4da88832b7$export$553d7fa8e3805fc0 = (year)=>{
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
};
module.exports["isLeapYear"] = $323f2e4da88832b7$export$553d7fa8e3805fc0;

});

parcelRegister("4eigd", function(module, exports) {

var $aKKC5 = parcelRequire("aKKC5");

const $927e6bf7203913f7$export$fcc71269590ba0a8 = (date, defaultFirstDay = false)=>{
    const now = (0, $aKKC5.toDateObj)(new Date());
    const { year: year, month: month, day: day } = date;
    // 19 should evaluate to 2019
    const fullYear = year < 100 ? 2000 + year : year;
    // Missing date pieces are filled in with their current date values
    const normalizedYear = !isNaN(fullYear) ? fullYear : now.year;
    const normalizedMonth = !isNaN(month) && month !== 0 ? month : now.month;
    const normalizedDay = !isNaN(day) && day !== 0 ? day : month !== 0 && defaultFirstDay ? 1 : now.day;
    return {
        year: normalizedYear,
        month: normalizedMonth,
        day: normalizedDay
    };
};
module.exports["normalizeDate"] = $927e6bf7203913f7$export$fcc71269590ba0a8;

});

parcelRegister("aKKC5", function(module, exports) {
const $00e4455f9b4cd7ae$export$abe96da78d4f59dd = (date)=>({
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
    });
module.exports["toDateObj"] = $00e4455f9b4cd7ae$export$abe96da78d4f59dd;

});

parcelRegister("2iEso", function(module, exports) {
const $f36e5bfee980e3d5$export$e67a095c620b86fe = (date)=>// The 'proper' month is stored in a DateObj but Date expects month index
    new Date(date.year, date.month - 1, date.day);
module.exports["toDate"] = $f36e5bfee980e3d5$export$e67a095c620b86fe;

});

parcelRegister("a6FC8", function(module, exports) {
const $5e4f9944cbc7c90e$export$9b7ca29af37c192 = (rawParts)=>rawParts.reduce((result, datePart)=>({
            ...result,
            [datePart.type]: datePart.value
        }), {});
module.exports["toFormattedParts"] = $5e4f9944cbc7c90e$export$9b7ca29af37c192;

});

parcelRegister("9k33u", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $grxv4 = parcelRequire("grxv4");


var $8IHds = parcelRequire("8IHds");

const $93e9546cb0a1512c$export$c94ff18a59d4c4d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(undefined);
const $93e9546cb0a1512c$export$57164260bc1f1218 = ({ children: children, mediaClientConfig: mediaClientConfig, mediaSettings: mediaSettings })=>{
    const mediaClient = (0, $42omo.useMemo)(()=>(0, $grxv4.getMediaClient)(mediaClientConfig), [
        mediaClientConfig
    ]);
    const settings = (0, $8IHds.useMediaParsedSettings)(mediaSettings);
    return /*#__PURE__*/ (0, $l998X.jsx)($93e9546cb0a1512c$export$c94ff18a59d4c4d.Provider, {
        value: {
            mediaClient: mediaClient,
            settings: settings
        },
        children: children
    });
};
module.exports["MediaContext"] = $93e9546cb0a1512c$export$c94ff18a59d4c4d;
module.exports["MediaProvider"] = $93e9546cb0a1512c$export$57164260bc1f1218;

});

parcelRegister("8IHds", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $82Dle = parcelRequire("82Dle");

const $ad9bb6183b9f6f81$export$d54af28440a5efc0 = (mediaSettings = {})=>{
    const settings = (0, $42omo.useMemo)(()=>{
        const newSettings = {
            ...mediaSettings
        };
        newSettings.mediaUserPreferences = (0, $82Dle.defaultMediaUserPreferences);
        return newSettings;
    }, [
        mediaSettings
    ]);
    return settings;
};
module.exports["useMediaParsedSettings"] = $ad9bb6183b9f6f81$export$d54af28440a5efc0;

});

parcelRegister("82Dle", function(module, exports) {
// Currently only supports boolean, string. Uncomment below to support number
const $3a61632aaf261ebb$var$MediaUserPreferencesTypes = {
    videoCaptionsEnabled: 'boolean',
    videoCaptionsPreferredLocale: 'string'
};
const $3a61632aaf261ebb$export$7e209e67b965bc63 = (userPreferences)=>({
        set: (key, value)=>{
            userPreferences.set(key, value.toString());
        },
        get: (key)=>{
            const value = userPreferences.get(key);
            if (value === null || value === undefined) return undefined;
            if ($3a61632aaf261ebb$var$MediaUserPreferencesTypes[key] === 'boolean') return value === 'true';
            // Uncomment to support number
            // if (MediaUserSettingsTypes[key] === 'number') {
            // 	return Number(value) as MediaSettingsTypeMap[K];
            // }
            return value;
        }
    });
const $3a61632aaf261ebb$var$defaultUserPreferences = {
    set: (key, value)=>{
        const MEDIA_KEY = 'media';
        localStorage.setItem(`${MEDIA_KEY}-${key}`, value);
    },
    get: (key)=>{
        const MEDIA_KEY = 'media';
        return localStorage.getItem(`${MEDIA_KEY}-${key}`);
    }
};
const $3a61632aaf261ebb$export$2d23ed2854ac1650 = $3a61632aaf261ebb$export$7e209e67b965bc63($3a61632aaf261ebb$var$defaultUserPreferences);
module.exports["defaultMediaUserPreferences"] = $3a61632aaf261ebb$export$2d23ed2854ac1650;

});

parcelRegister("jRNsq", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3rvSa = parcelRequire("3rvSa");


var $9k33u = parcelRequire("9k33u");

const $9c13c2ba0d10a1f7$export$8b3e87ea56c3a345 = ()=>{
    const mediaClient = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext((0, $3rvSa.MediaClientContext));
    const { mediaClient: altMediaClient } = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext((0, $9k33u.MediaContext)) || {};
    if (!mediaClient && !altMediaClient) throw new Error('No MediaClient set, use MediaClientProvider or MediaProvider to set one');
    // WARNING: typescript can't infer that at least one mediaClient is defined here. Adding the `!` is a hack to make typescript happy.
    return mediaClient || altMediaClient;
};
module.exports["useMediaClient"] = $9c13c2ba0d10a1f7$export$8b3e87ea56c3a345;

});

parcelRegister("7NoXb", function(module, exports) {
$parcel$export(module.exports, "default", () => $a320422a745418e6$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fs5Wi = parcelRequire("fs5Wi");


var $1GQGM = parcelRequire("1GQGM");


const $a320422a745418e6$var$MediaViewer = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("lAr0g")).then(({ MediaViewerWithErrorBoundary: MediaViewerWithErrorBoundary })=>({
            default: MediaViewerWithErrorBoundary
        })));
function $a320422a745418e6$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
        fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $fs5Wi.default), {}),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1GQGM.MediaViewerPortal), {
            children: /*#__PURE__*/ (0, $l998X.jsx)($a320422a745418e6$var$MediaViewer, {
                ...props
            })
        })
    });
}

});

parcelRegister("fs5Wi", function(module, exports) {
/**
 * Module loaded synchronously.
 * Must minimise dependencies.
 * */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $70BxX = parcelRequire("70BxX");


var $cOrQJ = parcelRequire("cOrQJ");

const $379228055afe24f5$export$442b7be89436c101 = '#101214';
const $379228055afe24f5$var$ModalSpinner = ()=>{
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $70BxX.default), {
        blankedColor: $379228055afe24f5$export$442b7be89436c101,
        invertSpinnerColor: colorMode !== 'dark'
    });
};
var $379228055afe24f5$export$2e2bcd8739ae039 = $379228055afe24f5$var$ModalSpinner;
module.exports["default"] = $379228055afe24f5$export$2e2bcd8739ae039;

});

parcelRegister("70BxX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9DX83 = parcelRequire("9DX83");

const $9f2ec0906c10b2d9$var$ModalSpinner = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9DX83.default), props);
var $9f2ec0906c10b2d9$export$2e2bcd8739ae039 = $9f2ec0906c10b2d9$var$ModalSpinner;
module.exports["default"] = $9f2ec0906c10b2d9$export$2e2bcd8739ae039;

});

parcelRegister("9DX83", function(module, exports) {
$parcel$export(module.exports, "default", () => $ed42ad447c5e042f$export$2e2bcd8739ae039);
/* modalSpinner-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $9hlns = parcelRequire("9hlns");

const $ed42ad447c5e042f$var$blanketStyles = null;
const $ed42ad447c5e042f$var$spinnerStyles = null;
const $ed42ad447c5e042f$var$defaultProps = {
    blankedColor: 'none',
    invertSpinnerColor: false
};
var $ed42ad447c5e042f$export$2e2bcd8739ae039 = ({ blankedColor: blankedColor, invertSpinnerColor: invertSpinnerColor })=>/*#__PURE__*/ $42omo.createElement("div", {
        style: {
            backgroundColor: blankedColor || $ed42ad447c5e042f$var$defaultProps.blankedColor
        },
        "data-testid": 'media-modal-spinner-blanket',
        className: (0, $gMc0m.default)([
            "_kqsw1n9t _154iidpf _1ltvidpf _94n5idpf _1xi2idpf _1pby1qpw"
        ])
    }, /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_kqswstnw _154i1ssb _1ltv1ssb _t9ec1ooe"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $9hlns.default), {
        size: "large",
        appearance: invertSpinnerColor || $ed42ad447c5e042f$var$defaultProps.invertSpinnerColor ? 'invert' : 'inherit',
        testId: 'media-modal-spinner'
    })));

});

parcelRegister("1GQGM", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $caX7N = parcelRequire("caX7N");

const $86b842c4b2e17806$export$51aee4c01b17acde = ({ children: children })=>// This zIndex matches with zIndex used by DS Modal and Jira Issue View Modal.
    // This value makes layers stack work correctly:
    //  -> Issue View -> Media Viewer -> DS Modal
    /*#__PURE__*/ (0, $l998X.jsx)((0, $caX7N.default), {
        zIndex: 510,
        children: children
    });
module.exports["MediaViewerPortal"] = $86b842c4b2e17806$export$51aee4c01b17acde;

});

parcelRegister("lAr0g", function(module, exports) {

let $fb71e80935e671d5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $fb71e80935e671d5$var$load("gOOwE"),
    $fb71e80935e671d5$var$load("5XqRg"),
    $fb71e80935e671d5$var$load("f35QR"),
    $fb71e80935e671d5$var$load("eVYW1"),
    $fb71e80935e671d5$var$load("ls0Um"),
    $fb71e80935e671d5$var$load("020xd"),
    $fb71e80935e671d5$var$load("eTBsW"),
    $fb71e80935e671d5$var$load("bYxCZ"),
    $fb71e80935e671d5$var$load("6HBYC"),
    $fb71e80935e671d5$var$load("eDqo1"),
    $fb71e80935e671d5$var$load("lxiFd"),
    $fb71e80935e671d5$var$load("1oiJ6"),
    $fb71e80935e671d5$var$load("huUvS"),
    $fb71e80935e671d5$var$load("6wr18"),
    $fb71e80935e671d5$var$load("llcfA"),
    $fb71e80935e671d5$var$load("azCDs"),
    $fb71e80935e671d5$var$load("dT77m"),
    $fb71e80935e671d5$var$load("8j9XC"),
    $fb71e80935e671d5$var$load("ffEVr"),
    $fb71e80935e671d5$var$load("6vhrJ"),
    $fb71e80935e671d5$var$load("fxC6e"),
    $fb71e80935e671d5$var$load("kknf5"),
    $fb71e80935e671d5$var$load("ajMch"),
    $fb71e80935e671d5$var$load("hPalR"),
    $fb71e80935e671d5$var$load("jDjSj"),
    $fb71e80935e671d5$var$load("8059b"),
    $fb71e80935e671d5$var$load("3QZdB"),
    $fb71e80935e671d5$var$load("3M4Om"),
    $fb71e80935e671d5$var$load("4jPsO"),
    $fb71e80935e671d5$var$load("72780"),
    $fb71e80935e671d5$var$load("hszIA"),
    $fb71e80935e671d5$var$load("2fk6g"),
    $fb71e80935e671d5$var$load("hhss7"),
    $fb71e80935e671d5$var$load("cKkZK")
]).then(()=>parcelRequire('gamJO'));

});

parcelRegister("i2CQL", function(module, exports) {

var $g99e4 = parcelRequire("g99e4");


var $jRNsq = parcelRequire("jRNsq");

const $4af3bbf76333cbc2$var$createBoundedUseStore = (store)=>(selector, equals)=>(0, $g99e4.useStore)(store, selector, equals);
function $4af3bbf76333cbc2$export$8a9cc8c330400af8(selector, equals) {
    const mediaClient = (0, $jRNsq.useMediaClient)();
    const store = mediaClient.__DO_NOT_USE__getMediaStore();
    const useBoundStore = $4af3bbf76333cbc2$var$createBoundedUseStore(store);
    return useBoundStore(selector, equals);
}
module.exports["useMediaStore"] = $4af3bbf76333cbc2$export$8a9cc8c330400af8;

});

parcelRegister("g99e4", function(module, exports) {
$parcel$export(module.exports, "useStore", () => $bc14a4aa688fca7b$export$6ccbb43953eebf8);

var $9mu1x = parcelRequire("9mu1x");


var $42omo = parcelRequire("42omo");


var $hpRUx = parcelRequire("hpRUx");

var $bc14a4aa688fca7b$import_meta = Object.assign(Object.create(null), {
    url: "file:///../platform/node_modules/zustand/esm/index.mjs"
});
const { useDebugValue: $bc14a4aa688fca7b$var$useDebugValue } = (0, (/*@__PURE__*/$parcel$interopDefault($42omo)));
const { useSyncExternalStoreWithSelector: $bc14a4aa688fca7b$var$useSyncExternalStoreWithSelector } = (0, (/*@__PURE__*/$parcel$interopDefault($hpRUx)));
let $bc14a4aa688fca7b$var$didWarnAboutEqualityFn = false;
const $bc14a4aa688fca7b$var$identity = (arg)=>arg;
function $bc14a4aa688fca7b$export$6ccbb43953eebf8(api, selector = $bc14a4aa688fca7b$var$identity, equalityFn) {
    if (($bc14a4aa688fca7b$import_meta.env ? $bc14a4aa688fca7b$import_meta.env.MODE : void 0) !== "production" && equalityFn && !$bc14a4aa688fca7b$var$didWarnAboutEqualityFn) {
        console.warn("[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937");
        $bc14a4aa688fca7b$var$didWarnAboutEqualityFn = true;
    }
    const slice = $bc14a4aa688fca7b$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getInitialState, selector, equalityFn);
    $bc14a4aa688fca7b$var$useDebugValue(slice);
    return slice;
}
const $bc14a4aa688fca7b$var$createImpl = (createState)=>{
    if (($bc14a4aa688fca7b$import_meta.env ? $bc14a4aa688fca7b$import_meta.env.MODE : void 0) !== "production" && typeof createState !== "function") console.warn("[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`.");
    const api = typeof createState === "function" ? (0, $9mu1x.createStore)(createState) : createState;
    const useBoundStore = (selector, equalityFn)=>$bc14a4aa688fca7b$export$6ccbb43953eebf8(api, selector, equalityFn);
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
const $bc14a4aa688fca7b$export$185802fd694ee1f5 = (createState)=>createState ? $bc14a4aa688fca7b$var$createImpl(createState) : $bc14a4aa688fca7b$var$createImpl;
var $bc14a4aa688fca7b$export$2e2bcd8739ae039 = (createState)=>{
    if (($bc14a4aa688fca7b$import_meta.env ? $bc14a4aa688fca7b$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use `import { create } from 'zustand'`.");
    return $bc14a4aa688fca7b$export$185802fd694ee1f5(createState);
};

});


//# sourceMappingURL=mediaInline.dd43c226.js.map
